<template>
    <div class="fs5-funnel-club" >
        <fs5-section-header :view="view.header" :showTooltip="view.header.showTooltip" />
        <div class="fs5-funnel-club-content" >
            <div class="fs5-funnel-club-content-text" v-html="view.content.text"></div>
            <fs5-button 
                :label="view.content.button.label"
                :btn-type="view.content.button.btnType"
                :text-transform-type="view.content.button.btnType"
                @clicked="openTab(view.content.button.link)"
            ></fs5-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fs5-funnel-club",
        props: ['view'],
        methods: {
            openTab(link) {
                window.open(link, '_blank');
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';

    .fs5-funnel-club{
        font: inherit;
        .fs5-funnel-club-content{
            font: inherit;
            display: grid;
            grid-template-columns: auto 40%;
            grid-template-rows: auto;
            justify-content: stretch;
            align-items: center;
            column-gap: 4.1666667vw;

            .fs5-funnel-club-content-text{
                font: inherit;
                font-size: 1.9em;
                line-height: 1.2;
                color: $fs5-color4;
                text-align: justify;
            }
        }
    }

    @media screen and (max-width: 700px){
        .fs5-funnel-club{
            .fs5-funnel-club-content{
                grid-template-columns: 1fr;
                row-gap: 2em;
                .fs5-funnel-club-content-text{
                    padding: 0 10px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/funnel_club/index.vue